import React from "react";
import Reveal from "./Reveal";

const CASES = [
    {
        img: "https://images.unsplash.com/photo-1593011951342-8426e949371f?auto=format&fit=crop&q=80&w=800",
        cat: "Квітковий магазин · Варшава",
        metric: "+67 замовлень/міс",
        text: "Було: $180 витрат, 4 замовлення. Стало: $210 витрат, 71 замовлення.",
        note: "Через 6 тижнів після запуску",
    },
    {
        img: "https://images.pexels.com/photos/33388390/pexels-photo-33388390.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
        cat: "Сантехнічні послуги · Краків",
        metric: "CPA $3.80",
        text: "Раніше платив $400/міс агентству. Тепер $50/міс AutoAds.",
        note: "Перший вимір через 3 тижні",
    },
    {
        img: "https://images.unsplash.com/photo-1603693958284-f8dcd5902279?auto=format&fit=crop&q=80&w=800",
        cat: "Косметологія · Київ",
        metric: "3.2× більше записів",
        text: "Перший місяць: 8 записів з реклами. Другий: 26.",
        note: "Стабільне зростання другий квартал",
    },
];

export const Results = () => {
    return (
        <section className="section" data-testid="results-section">
            <div className="container-mx">
                <Reveal>
                    <h2 className="font-display font-extrabold text-text-primary" style={{ fontSize: "clamp(36px, 5vw, 56px)", letterSpacing: "-0.025em" }}>
                        Не обіцянки. <span className="text-success-c">Числа.</span>
                    </h2>
                </Reveal>

                <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-7">
                    {CASES.map((c, i) => (
                        <Reveal key={i} delay={i * 0.1}>
                            <article
                                data-testid={`case-${i}`}
                                className="glass glass-hover rounded-2xl overflow-hidden h-full flex flex-col"
                            >
                                <div className="aspect-[4/3] overflow-hidden">
                                    <img
                                        src={c.img}
                                        alt={c.cat}
                                        className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="p-6 flex flex-col flex-1">
                                    <div className="text-xs text-secondary-c font-mono uppercase tracking-wider">{c.cat}</div>
                                    <div className="mt-4 font-mono font-bold text-success-c" style={{ fontSize: "36px", letterSpacing: "-0.02em" }}>
                                        {c.metric}
                                    </div>
                                    <p className="mt-4 text-sm text-text-primary/90 leading-relaxed">{c.text}</p>
                                    <div className="mt-auto pt-4 text-xs text-faint-c">{c.note}</div>
                                </div>
                            </article>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Results;
